import { COLOR } from '@src/styles/color';
import { Box, Checkbox } from '@mui/material';
import React from 'react';
import CommonButton from '@src/new-components/Button';
import Typography from '@src/new-components/Typography';
import { useTranslation } from 'react-i18next';

const DeviceSelect = ({
  selectAll,
  numberDevices,
  hasSelectDevice,
  onSelectAll,
  onSelect,
  onCancel,
  onLogout,
}) => {
  const { t } = useTranslation();

  const getSelectedDeviceText = () => {
    if (selectAll) return t('deselectAll');
    if (!numberDevices) return t('selectAll');
    return t('selectedDevice', { numberDevices });
  };

  return (
    <>
      {!hasSelectDevice && (
        <div className="other-device">
          <div className="title-device">{t('otherDevices')}:</div>
          <Typography
            variant="body-14-bold"
            color={COLOR.darkBlue}
            margin="8px 12px"
            onClick={onSelect}
          >
            {t('selectMultipleDevices')}
          </Typography>
        </div>
      )}

      {hasSelectDevice && (
        <div className="other-device-select">
          <Box className="device-select-wrapper">
            <Checkbox
              className="device-checkbox"
              checked={selectAll}
              onChange={onSelectAll}
              size="medium"
            />
            <Typography variant="body-16-medium" alignSelf="center">
              {getSelectedDeviceText()}
            </Typography>
          </Box>
          <Box className="device-select-btn">
            <CommonButton
              variant="outlineSmall"
              textProps={{
                variantText: 'body-14-bold',
                color: COLOR.indigo.default,
              }}
              customStyle={{
                height: '40px',
              }}
              onClick={onCancel}
            >
              {t('cancel')}
            </CommonButton>
            <CommonButton
              variant="containedSmall"
              textProps={{
                variantText: 'body-14-bold',
                color: COLOR.indigo.default,
              }}
              customStyle={{
                height: '40px',
                border: 'none',
              }}
              onClick={onLogout}
              disabled={!numberDevices}
            >
              {t('logout')}
            </CommonButton>
          </Box>
        </div>
      )}
    </>
  );
};

export default DeviceSelect;
